/* eslint-disable import/no-default-export */
import { numberOrStringOrArray } from './types';


const sx = [
  'margin',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'marginX',
  'marginY',
  'padding',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
  'paddingX',
  'paddingY',
  'm',
  'mt',
  'mr',
  'mb',
  'ml',
  'mx',
  'my',
  'p',
  'pt',
  'pr',
  'pb',
  'pl',
  'px',
  'py',
];

const propTypes = {
  margin: numberOrStringOrArray,
  marginTop: numberOrStringOrArray,
  marginRight: numberOrStringOrArray,
  marginBottom: numberOrStringOrArray,
  marginLeft: numberOrStringOrArray,
  marginX: numberOrStringOrArray,
  marginY: numberOrStringOrArray,
  padding: numberOrStringOrArray,
  paddingTop: numberOrStringOrArray,
  paddingRight: numberOrStringOrArray,
  paddingBottom: numberOrStringOrArray,
  paddingLeft: numberOrStringOrArray,
  paddingX: numberOrStringOrArray,
  paddingY: numberOrStringOrArray,
  m: numberOrStringOrArray,
  mt: numberOrStringOrArray,
  mr: numberOrStringOrArray,
  mb: numberOrStringOrArray,
  ml: numberOrStringOrArray,
  mx: numberOrStringOrArray,
  my: numberOrStringOrArray,
  p: numberOrStringOrArray,
  pt: numberOrStringOrArray,
  pr: numberOrStringOrArray,
  pb: numberOrStringOrArray,
  pl: numberOrStringOrArray,
  px: numberOrStringOrArray,
  py: numberOrStringOrArray,
};

export default {
  sx,
  propTypes,
};
